import React from 'react'
import { Grid, Row, Col, Button, Glyphicon } from 'react-bootstrap'
import Input from '../containers/Input'
import Context from '../containers/Context'
import Preview from '../containers/Preview'
import UploadModal from '../containers/UploadModal'

export default class Wrapper extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      scroll: '',
      top: '',
      height: ''
    }
    this.handleScroll = this.handleScroll.bind(this)
  }

  handleScroll () {
    this.setState({scroll: window.scrollY})
  }

  componentDidMount () {
    this.props.setVocabularies()

    const el = document.querySelector('#previewContents')
    this.setState({top: el.offsetTop, height: el.offsetHeight})
    window.addEventListener('scroll', this.handleScroll)
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.user.uid !== this.props.user.uid) {
      this.props.getGistList(this.props)
    }
  }
  
  render () {
    return (
      <Grid style={{marginBottom: '40px'}}>
        <h1 id="appTitle">JSON2LD Mapper</h1>
        <Row>
          <Col md={12} className="button_wrapper">
            <Button onClick={this.props.startTutorial} className="border_button">Tutorial</Button>
            <a href="https://docs.json2ld.mapper.tokyo/" target="_blank" rel="noopener noreferrer">
              <Button className="border_button">
                Docs <Glyphicon glyph="new-window"/>
              </Button>
            </a>
            {this.props.user.uid ? <p>Hello {this.props.user.displayName}.</p> :
              <Button className="border_button" onClick={this.props.loginWithGithub}　id="loginWithGithub">
                Login with GitHub
              </Button>}
          </Col>
        </Row>

        <div className="components_wrapper">
          <div className="components_wrapper__left">
            <Input/>

            {Object.keys(this.props.inputKeys).length > 0 ?
              <div className="flow_border row">
                <div className="switch_button_wrapper direct_button">
                  <div className="switch_button">
                    <input type="checkbox" id="switchButton1" className="switch_button__input"
                           onClick={e => this.props.handleClickAdvanced(e)}/>
                    <label htmlFor="switchButton1" className="switch_button__label">
                      <span className="switch_button__text">Advanced Mode</span>
                    </label>
                  </div>
                </div>
              </div>
              : null}

            <Context/>
          </div>

          <div id="previewContents"
               className={(this.state.scroll < 50 ? this.state.scroll : this.state.scroll + 50) > this.state.top ? 'components_wrapper__right fixed' : 'components_wrapper__right'}>
            <Preview/>
          </div>
        </div>

        {this.props.showUploadModal ? <UploadModal/> : null}
      </Grid>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Wrapper.js